import { createContext, useContext } from 'react';

export const LayoutContext = createContext({
  isMobile: false,
  isAuto: true,
  toggleLayout: () => {},
  resetAuto: () => {}
});

export function useLayout() {
  return useContext(LayoutContext);
}
